<template>
  <user-item
    :user="user"
    class="full-width q-pt-xs staff-availability-item"
    without-email
  >
    <div>
      <q-chip
        :color="statusOption.color"
        text-color="white"
        dense
        square
        class="q-mr-lg"
      >
        <q-icon :name="statusOption.icon" />
        <span class="q-ml-sm">{{ statusOption.description }}</span>
      </q-chip>

      <cancel-button
        v-if="canEdit"
        selector=".staff-availability-item"
        hover-selector-class="bg-red-1"
        label="Remove From Appointment"
        @click="$emit('remove')"
      />
    </div>
  </user-item>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      required: true
    },
    availability: {
      type: String,
      default: 'available'
    },
    canEdit: {
      type: Boolean,
      default: false
    }
  },
  emits: ['remove'],
  data () {
    return {
      statusOptions: [
        { value: 'available', color: 'green-7', icon: 'done', description: 'Available' },
        { value: 'warning', color: 'orange-8', icon: 'mdi-exclamation', description: 'Unavailable' },
        { value: 'unavailable', color: 'red', icon: 'mdi-calendar-remove', description: 'Overlap' }
      ]
    }
  },
  computed: {
    statusOption () {
      return this.statusOptions.find(item => item.value === this.availability)
    }
  }
}
</script>
